namespace SP.Data {
    export class PurchaseOrder {

        static async getPurchaseOrder(id: number): Promise<purchaseOrderInfo> {
            var response = await SP.get<any>("/api/v1/purchaseorder/get/" + id);
            if (response.status == 200) return response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }


        static async getBarcodeSearch(barcode: string, includeLines: boolean = false): Promise<purchaseOrderInfo[]> {
            var bc = encodeURIComponent(barcode);
            var response = await SP.get<any>(`/api/v1/purchaseorder/barcodesearch/?barcode=${bc}&warehouseInfo=true&includeLines=${includeLines}`);
            if (response.status == 200) return response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getPurchaseOrders(customerId: string, type: PurchaseOrderType, state: PurchaseOrderState, keyword:string = "", includeLines:boolean = false) {
            const response = await fetch(`/api/v1/purchaseorder/list?type=${type}&state=${state}&keyword=${keyword}&warehouseInfo=true&includeLines=${includeLines}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'api-customer': `${customerId}`
                }
            });

            const result = await response.json();
            if (result.status = !200) await SP.alertX(result.msg);

            return result.data as purchaseOrderInfo[];
        }
    }
}